module.exports = __webpack_public_path__ + "static/img/szpt42.7fe76f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szpt42.jpg
// module id = RHhL
// module chunks = 73